(function(){
  // ---------- Header scroll state ----------
  var header = document.getElementById('gpHeader');
  if(header){ window.addEventListener('scroll', function(){ header.classList.toggle('scrolled', window.scrollY > 12); }); }

  // ---------- Mobile menu ----------
  var burger = document.getElementById('gpBurger'), menu = document.getElementById('gpMobileMenu');
  if(burger && menu){ burger.addEventListener('click', function(){ menu.classList.toggle('open'); }); }

  // ---------- Hero carousel (headline + image rotate together) ----------
  var carousel = document.getElementById('gpHeroCarousel');
  if(carousel){
    var slides = [].slice.call(carousel.querySelectorAll('.gp-hero-slide'));
    var dots   = document.getElementById('gpDots');
    var headEl = document.getElementById('gpHeadline');
    var subEl  = document.getElementById('gpHeroSub');
    var idx = 0, timer;

    // Build the headline from plain text only (no innerHTML) to avoid any injection risk.
    function paintHeadline(slide){
      if(!headEl) return;
      var parts = (slide.getAttribute('data-head') || '').split('|');
      while(headEl.firstChild){ headEl.removeChild(headEl.firstChild); }
      var hl = document.createElement('span');
      hl.className = 'hl';
      hl.textContent = parts[0] || '';
      headEl.appendChild(hl);
      if(parts[1]){ headEl.appendChild(document.createElement('br')); headEl.appendChild(document.createTextNode(parts[1])); }
      if(subEl){ subEl.textContent = slide.getAttribute('data-cap') || subEl.textContent; }
    }
    function show(i){
      idx = (i + slides.length) % slides.length;
      slides.forEach(function(s,j){ s.classList.toggle('is-on', j===idx); });
      if(dots){ [].forEach.call(dots.children, function(d,j){ d.classList.toggle('on', j===idx); }); }
      paintHeadline(slides[idx]);
    }
    function start(){ timer = setInterval(function(){ show(idx+1); }, 4800); }
    function go(i){ clearInterval(timer); show(i); start(); }

    show(0); start();
    var p = document.getElementById('gpPrev'), n = document.getElementById('gpNext');
    if(p) p.addEventListener('click', function(){ go(idx-1); });
    if(n) n.addEventListener('click', function(){ go(idx+1); });
    if(dots) [].forEach.call(dots.children, function(d,j){ d.addEventListener('click', function(){ go(j); }); });
  }

  // ---------- Product gallery thumbnails ----------
  var galleryMain = document.getElementById('gpGalleryMain');
  if(galleryMain){
    [].forEach.call(document.querySelectorAll('.gp-thumb'), function(t){
      t.addEventListener('click', function(){
        var full = t.getAttribute('data-full'); if(!full) return;
        galleryMain.src = full;
        [].forEach.call(document.querySelectorAll('.gp-thumb'), function(x){ x.classList.remove('is-on'); });
        t.classList.add('is-on');
      });
    });
  }

  // ---------- Testimonials carousel ----------
  var quotesWrap = document.getElementById('gpQuotes');
  if(quotesWrap){
    var qs = [].slice.call(quotesWrap.querySelectorAll('.gp-quote'));
    var qdots = document.getElementById('gpQDots');
    var qidx = 0, qtimer;
    function qshow(i){
      qidx = (i + qs.length) % qs.length;
      qs.forEach(function(s,j){ s.classList.toggle('is-on', j===qidx); });
      if(qdots){ [].forEach.call(qdots.children, function(d,j){ d.classList.toggle('on', j===qidx); }); }
    }
    function qstart(){ qtimer = setInterval(function(){ qshow(qidx+1); }, 6000); }
    function qgo(i){ clearInterval(qtimer); qshow(i); qstart(); }
    qshow(0); qstart();
    var qp = document.getElementById('gpQPrev'), qn = document.getElementById('gpQNext');
    if(qp) qp.addEventListener('click', function(){ qgo(qidx-1); });
    if(qn) qn.addEventListener('click', function(){ qgo(qidx+1); });
    if(qdots) [].forEach.call(qdots.children, function(d,j){ d.addEventListener('click', function(){ qgo(j); }); });
  }

  // ---------- Quantity steppers ----------
  [].forEach.call(document.querySelectorAll('.gp-qty'), function(q){
    var input = q.querySelector('input');
    q.addEventListener('click', function(e){
      var b = e.target.closest('button'); if(!b) return;
      var v = parseInt(input.value,10) || 1;
      v = b.getAttribute('data-q')==='+' ? v+1 : Math.max(1, v-1);
      input.value = v;
    });
  });

  // ---------- Add to cart (Shopify AJAX) ----------
  function setCount(n){ var c=document.getElementById('gpCartCount'); if(c) c.textContent = n; }
  [].forEach.call(document.querySelectorAll('.gp-add'), function(btn){
    btn.addEventListener('click', function(){
      var id = btn.getAttribute('data-variant');
      var qty = parseInt(btn.getAttribute('data-qty'),10);
      if(!qty){ var t = btn.getAttribute('data-qtytarget'); var el = t && document.getElementById(t); qty = el ? (parseInt(el.value,10)||1) : 1; }
      btn.disabled = true; var label = btn.textContent; btn.style.opacity=.7;
      fetch('/cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ items:[{ id: Number(id), quantity: qty }] })
      }).then(function(r){ return r.json(); }).then(function(){
        return fetch('/cart.js').then(function(r){return r.json();});
      }).then(function(cart){
        setCount(cart.item_count);
        window.location.href = '/cart';
      }).catch(function(){ btn.disabled=false; btn.style.opacity=1; btn.textContent=label; alert('Could not add to cart. Please try again.'); });
    });
  });

  // ---------- Scroll-reveal (fade-up on enter) ----------
  var reveals = [].slice.call(document.querySelectorAll('.gp-reveal'));
  if(reveals.length){
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
      }, { threshold:.12, rootMargin:'0px 0px -8% 0px' });
      reveals.forEach(function(el){ io.observe(el); });
    } else {
      reveals.forEach(function(el){ el.classList.add('in'); });
    }
  }

  // ---------- Cart page: quantity steppers + remove ----------
  // Updates go through /cart/change.js then reload, because quantity-based
  // automatic discounts (2→5%, 3→7%, 5→10%) re-tier on each change and Shopify
  // re-keys the line item — so we let the server re-render for correctness.
  var cartEl = document.getElementById('gpCart');
  if(cartEl){
    var busy = false;
    function changeQty(key, qty){
      if(busy) return; busy = true;
      cartEl.classList.add('is-updating');
      fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function(){ window.location.reload(); })
        .catch(function(){ window.location.reload(); });
    }
    [].forEach.call(cartEl.querySelectorAll('.gp-cart-qty'), function(grp){
      var key = grp.getAttribute('data-key');
      var qEl = grp.querySelector('.gp-cart-q');
      [].forEach.call(grp.querySelectorAll('.gp-cart-step'), function(b){
        b.addEventListener('click', function(){
          var cur = parseInt(qEl.textContent, 10) || 1;
          var next = b.getAttribute('data-step') === '+' ? cur + 1 : Math.max(0, cur - 1);
          changeQty(key, next);
        });
      });
    });
    [].forEach.call(cartEl.querySelectorAll('.gp-cart-remove'), function(rm){
      rm.addEventListener('click', function(){ changeQty(rm.getAttribute('data-key'), 0); });
    });
  }

  // ---------- Scroll-to-top button ----------
  var toTop = document.getElementById('gpToTop');
  if(toTop){
    window.addEventListener('scroll', function(){ toTop.classList.toggle('show', window.scrollY > 480); });
    toTop.addEventListener('click', function(){ window.scrollTo({ top:0, behavior:'smooth' }); });
  }
})();
